import React from "react";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
} from "./Header.styled";
import { Typography, Button } from "@ann/web-components";

const Header = ({ onCreateClick }) => {
  const handleButtonClick = () => {
    onCreateClick?.();
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <TypographyContainer>
          <Typography category="title" size="large" weight="bold">
            Departments
          </Typography>

          <Typography category="body" size="medium" weight="regular" color="body">
            Manage department structure, access, and configurations.
          </Typography>
        </TypographyContainer>
      </HeaderLeftContainer>

      <HeaderRightContainer>
        <Button
          iconRight="plus"
          label="Create Department"
          size="medium"
          onClick={handleButtonClick}
          type="gradient"
        />
      </HeaderRightContainer>
    </HeaderContainer>
  );
};

export default Header;

